module.exports = __webpack_public_path__ + "static/img/bnr_seminar_concierge.24c1540.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/bnr_seminar_concierge.png
// module id = duZV
// module chunks = 0